<div class="footer-container">
  <footer id="footer" class="footer">
    <div class="footerOsaic">
      <div class="footer-left">
        <img class="img-fluid" src="assets/images/Osaic-Logo.svg" alt="Osaic Logo">
        <!--<p><span class="big-contact">Contact:</span><br/>
          <a class="mt-1" href="mailto:meetings@osaic.com">meetings&#64;osaic.com</a>
        </p>-->
      </div>
      <div class="footer-right">
        <div class="container">
          <!-- Maritz -->
          <div class="footerMaritz">
            <div class="text-left">
                <a tabindex="0" (click)="openModal('termsOfUse', 'About This Site', 'Close');"  (keydown.enter)="openModal('termsOfUse', 'About This Site', 'Close');"  rel="noopener noreferrer">
                  {{"copy.label.FOOTER.termsofuse" | copy | async}}
                </a>
                <span>&#124;&#124;</span>
                <a tabindex="0" href="https://osaic.com/disclosures/privacy-policy" target="_blank" rel="noopener noreferrer">
                  {{"copy.label.FOOTER.privacy" | copy | async}} <svg class="outsideLinkSVG" width="25" height="25" viewBox="0 0 24 24">
                <path d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z"></path>
              </svg>
                </a>
                <span>&#124;&#124;</span>
                <!-- <a tabindex="0" (click)="openModalExternal('https://mge-cdn.prodtravelhq.com/policies/mge_cookie_policy.html', 'Cookie Policy', 'Close')" (keydown.enter)="openModalExternal('https://mge-cdn.prodtravelhq.com/policies/mge_cookie_policy.html', 'Cookie Policy', 'Close')">
                  Cookie Policy
                </a> -->
                <!-- OneTrust Cookies Settings button start -->
                <a tabindex="0" class="ot-sdk-show-settings" id="cookieSettings" tabindex="0" (keyup.enter)="cookieEnter()">Cookie Settings</a>
                <!-- OneTrust Cookies Settings button end -->
              </div>
              <div class="text-left mt-2">
                <a href="https://maritz.com" target="_blank" rel="noopener noreferrer"
                  >Powered by <span class="sr-only">Maritz</span> <svg class="svg-fill mtlogo" aria-hidden="true">
                    <use xlink:href="assets/images/maritz-logo.svg#maritz"></use>
                  </svg> <svg class="outsideLinkSVG" width="25" height="25" viewBox="0 0 24 24">
                <path d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z"></path>
              </svg></a>
              </div>
          </div>
          <!-- Osaic -->
          <div>
            <p>
              Securities and investment advisory services are offered through the firms: Osaic Wealth, Inc. and Osaic Institutions, Inc., broker-dealers, registered investment advisers, and members of FINRA and SIPC. Securities are offered through Osaic Services, Inc. and Ladenburg Thalmann & Co., broker-dealers and members of FINRA and SIPC. Advisory services are offered through Ladenburg Thalmann Asset Management, Inc., Osaic Advisory Services, LLC. and CW Advisors, LLC., registered investment advisers. Advisory programs offered by Osaic Wealth, Inc. are sponsored by VISION2020 Wealth Management Corp., an affiliated registered investment adviser.</p>
            <p>
              &copy; Osaic, Inc. &#8226; <a href="https://www.osaic.com" target="_blank" rel="noopener noreferrer">osaic.com <svg class="outsideLinkSVG" width="25" height="25" viewBox="0 0 24 24">
                <path d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z"></path>
              </svg></a> 8148894
            </p>
          </div>
        </div>
      </div>
  </div>
  </footer>
</div>
